import Button from '@narvar/nth-button';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loader from '../../Loader';

export const mapStateToProps = ({
  language = {},
  retailerSettings: {
    branding: { brand_call_to_action: ctaColor, brand_call_to_action_hover: ctaHoverColor } = {},
  } = {},
}) => ({
  language,
  ctaColor,
  ctaHoverColor,
});

const ConfirmButton = ({
  language,
  id,
  ctaColor,
  ctaHoverColor,
  disabled,
  confirmPayment,
  validationError,
  confirmingCard,
}) =>
  confirmingCard ? (
    <Loader />
  ) : (
    <Button
      disabled={Boolean(validationError) || disabled}
      className="narvar-btn-primary"
      big
      onClick={confirmPayment}
      s={{
        fontFamily: 'inherit',
        fontSize: 'inherit',
        height: '2.5rem',
        backgroundColor: ctaColor,
        hover: {
          backgroundColor: ctaHoverColor,
        },
      }}
    >
      {language[`returns.stripe.${id}.card_submit_button`] ||
        language[`returns.stripe_card_submit_button`]}
    </Button>
  );

ConfirmButton.defaultProps = {
  ctaColor: undefined,
  ctaHoverColor: undefined,
  disabled: false,
};

ConfirmButton.propTypes = {
  language: PropTypes.object.isRequired,
  ctaColor: PropTypes.string,
  ctaHoverColor: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  confirmPayment: PropTypes.func.isRequired,
  validationError: PropTypes.string.isRequired,
  confirmingCard: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ConfirmButton);
